export enum AppRoutes {
  SEARCH_PAGE = 'search',
  LANDING_PAGE = 'landing-page',
  DATA_ENTRY_PAGE = 'data-entry-page',
  NOT_AUTHORIZED_PAGE = 'not-authorized',
}
